import { render, staticRenderFns } from "./CreateDancer.vue?vue&type=template&id=23500158"
import script from "./CreateDancer.vue?vue&type=script&lang=js"
export * from "./CreateDancer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports